import { newsList } from '@/mocks/news';
import NewsCard from '@/components/feature/NewsCard';
import SectionHeading from '@/components/base/SectionHeading';
import EmptyState from '@/components/base/EmptyState';

export default function NewsSection() {
  const latest = [...newsList].sort((a, b) => b.date.localeCompare(a.date)).slice(0, 5);

  return (
    <section>
      <SectionHeading
        title="最新影视资讯"
        subtitle="剧集动态、主创访谈与幕后揭秘"
        icon="ri-newspaper-line"
        moreTo="/news"
        moreLabel="更多资讯"
      />
      {latest.length === 0 ? (
        <EmptyState title="暂无资讯更新" description="新的影视资讯正在整理中，敬请期待。" />
      ) : (
        <div className="space-y-3 md:space-y-4">
          {latest.map((item) => (
            <NewsCard key={item.id} news={item} />
          ))}
        </div>
      )}
    </section>
  );
}